import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import { getDynamicFormData, getViewJobDetails, loadMasterData } from "./action";
import { viewJobSelector } from "./selector";
import ViewCertification from "./ViewCertification";
import ViewClaimedCandidateInfo from "./ViewClaimedCandidateInfo";
import ViewEducationInfo from "./ViewEducationInfo";
import ViewJobInfo from "./ViewJobInfo";
import ViewLocationInfo from "./ViewLocationInfo";
import ViewMedicalSpeciality from "./ViewMedicalSpeciality";
import ViewShiftInfo from "./ViewShiftInfo";
import OccurrenceDetail from "./occurrenceDetail";
import ViewCovidVaccine from "./ViewCovidVaccine";
import ViewEmrehrSystemExperience from "./ViewEmrehrSystemExperience";
import ViewSummaryDyanamicJob from "./ViewSummaryDyanamicJob";
import useSessionStorage from "../../hooks/useSessionStorage";
import { useNavigate } from "react-router-dom";
import ViewTemplateInfo from "./ViewTemplateInfo";
import Spinner from "../common/Spinner/spinner";
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch();
  const { requestData, jobDetails, dropDownJobId, loadingFlag } =
    useSelector(viewJobSelector);
  const [filterJobList, setFilterJobList] = useState({});
  const storage = useSessionStorage();
  const navigate = useNavigate()
  const login = storage.getItem('login');
  const { jobId, shiftDate, claimId } = requestData;
  const config = useConfiguration();

  //console.log(jobDetails, '=========>');

  // useEffect(() => {
  //   if (config.baseUrl) {
  //     dispatch(loadMasterData(`${config.baseUrl}`)).then(() => {
  //       dispatch(
  //         getViewJobDetails({
  //           url: config?.baseUrl,
  //           jobUniqueId: jobId,
  //           jobsClaimId: claimId,
  //           shiftDate: shiftDate,
  //         })
  //       );
  //     });
  //   }
  // }, [config]);
  useEffect(() => {
    if (config.baseUrl) {
      if (!login) {
        navigate('/');
      } else {
        if (jobId) {
          dispatch(loadMasterData(`${config.baseUrl}`)).then(() => {
            dispatch(
              getViewJobDetails({
                url: config?.baseUrl,
                jobUniqueId: jobId,
                jobsClaimId: claimId,
                shiftDate: shiftDate,
              })
            );
          })

        }
      }
    }
  }, [config, jobId]);

  useEffect(() => {
    let filterVal = [];
    if (dropDownJobId) {
      filterVal = login.jobTypeFlags.jobTypeList.filter(
        (item) => item.jobTypeId === dropDownJobId
      )[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }
    } else {
      filterVal = login.jobTypeFlags.jobTypeList[0]; // login.jobTypeFlags.jobTypeList.map(item => item.jobTypeId);
      //console.log("inside else",filterVal);
      if (filterVal) {
        setFilterJobList(filterVal);
      }
    }
  }, [dropDownJobId]);

  return (
    <>
      <div className="card">
        {loadingFlag > 0 && <Spinner />}
        <div className="card-body">
          <ViewLocationInfo {...jobDetails} />
          {
            jobDetails?.claimedCandidateInfo && <ViewClaimedCandidateInfo
              claimedCandidateInfo={jobDetails?.claimedCandidateInfo}
              requestData={requestData}
              jobSummeryJobsShifts={jobDetails?.jobSummeryJobsShifts}
              candidateBillingsInfo={jobDetails?.candidateBillingsInfo}
              allShiftCompleted={jobDetails?.allShiftCompleted}
              encounterCompletedDate={jobDetails?.completedDateT0oDisplay}
              shiftHours={jobDetails?.shiftHours}
              rrurleStr={jobDetails?.rrurleStr}
              jobEncounterOccurreneList={jobDetails?.jobEncounterOccurreneList}
              deletedOccurence={jobDetails?.deletedOccurence}
              modifiedOccurreneList={jobDetails?.modifiedOccurreneList}
              pageName={props?.pageName}
              jobTitle={jobDetails?.jobTitle}
              save={requestData?.save}
              {...jobDetails}
              closePopup={props?.closePopup}
            />
}
          {/* {jobDetails?.deletedOccurence?.length ||
        jobDetails?.modifiedOccurreneList?.length ? (
          <OccurrenceDetail {...jobDetails} />
        ) : (
          ""
        )} */}
          {/* <ViewShiftInfo
            {...jobDetails}
            save={requestData?.save}
            currentShiftDate={shiftDate}
            jobSummeryJobsShifts={jobDetails?.jobSummeryJobsShifts}
            candidateBillingsInfo = {jobDetails?.candidateBillingsInfo}
            jobEncounterOccurreneList={jobDetails?.jobEncounterOccurreneList}
          /> */}
          {/* {requestData?.save &&  <ViewJobInfo {...jobDetails} save={requestData?.save} />} */}
          {/* <ViewEducationInfo {...jobDetails} /> */}
          {/* {(filterJobList?.showSpecialties && jobDetails?.employerJobSpecialtyList?.length > 0) && (
            <>
              <ViewMedicalSpeciality {...jobDetails} />
            </>
          )} */}
          {/* {(filterJobList?.showCertifications && jobDetails?.certificationsList?.length > 0) && (
            <>
              <ViewCertification {...jobDetails} />
            </>
          )} */}
          {/* {(filterJobList?.showEmr && jobDetails?.employerJobEMREHRSystemList?.length > 0)&& (
            <>
              <ViewEmrehrSystemExperience {...jobDetails} />
            </>
          )} */}
          {/* deparmentInfo */}
          {/* <div className="card mb-2">
            <div className="card-header">
              <h4 className="mb-0">Departments</h4>
            </div>

            <div className="card-body">
              <div className="form-group">
                <>
                  {" "}
                  <div className="col-lg-4 col-md-4">
                    {
                      <label htmlFor="departmentDetails">
                        {jobDetails?.departmentDetails
                          ?.map((deps) => <p>{deps?.name}</p>)}
                      </label>
                    }
                  </div>
                </>
              </div>
            </div>
          </div> */}
          {/* {
            jobDetails?.employerCovid19VaccinatedPreferencesList?.length > 0 && <ViewCovidVaccine {...jobDetails} />
          } */}
          
          {/* {filterJobList?.jobTypeId &&
            login?.accountFlags?.isShowQATab && <ViewSummaryDyanamicJob {...jobDetails} />} */}
          {/* {jobDetails?.jobTemplateName && <ViewTemplateInfo  {...jobDetails} />} */}
        </div>
      </div>
    </>
  );
};
